import { createStyles, makeStyles, Theme, createTheme } from '@material-ui/core/styles';

const defaultTheme = createTheme({});
const { pxToRem } = defaultTheme.typography;


export const TableBaseStyle = makeStyles(
  createStyles({
    //テーブルヘッダセル
    headerCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
      padding: '1px',
      minWidth: '80px',
      borderCollapse: `collapse`,
    },
    headerCell_s: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
      padding: '1px',
      minWidth: '0px',
      borderCollapse: `collapse`,
    },

    bodyCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0.5px',
      height: '10px',
    },
    bodyCellCenter: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      orderBottomStyle: 'inset',
      borderLeftStyle: 'solid',
      borderRightStyle: 'solid',
      textAlign: 'center',
      minWidth: '80px',
      height: '8px',
      padding: '1px',
    },
    bodyRow: {
      '&.Mui-selected, &.Mui-selected:hover': {
        //背景色
        backgroundColor: 'yellow',
        '& > .MuiTableCell-root': {
          //文字色
          color: 'brack',
        },
      },
    },
    cellName: {
      borderStyle: 'none',
      width: '60px',
    },
    cellData: {
      borderStyle: 'none',
      width: '220px',
    },
    //テキスト
    textField: {
      flexGrow: 1,
      height: '100%',
      width: '98%',
      backgroundcolor: 'transparent',
      borderBottom: '1px solid #000000',
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      backgroundColor: 'transparent',
      textAlign: 'center',
    },
    gridStyle: {
      borderStyle: 'solid',
      maxWidth: '1440px',
    },

  })
);

export const ChartBaseStyle = makeStyles(
  createStyles({
    tooltip: {
      background: '#FFFFEE',
      fontSize: '14px',
      padding: '10px 10px 0px 20px',
    },
  })
);

export const RealtimeSettingStyle = makeStyles(
  createStyles({
    activeRow: {
      background: '#7fffd4',
    },
    itemRow: {
      display: 'flex',
      alignItems: 'center',
      height: '60px',
    },
    itemSelLabel: {
      marginTop: '2px',
      marginLeft: '16px',
    },
    itemSelData: {
      marginTop: '2px',
      marginLeft: '16px',
    },
    entryLabel: {
      marginTop: '4px',
    },
    gridStyle: {
      borderStyle: 'solid',
      //maxWidth: '1200px',
      // height: 'calc(100vh - 400px)',
    },
    settingContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      margin: '4px',
    },
    entry: {
      marginLeft: '8px',
      marginRight: '8px',
      width: '64px',
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      margin: '4px',
    },
    button: {
      width: '150px',
      marginTop: '2px',
      marginRight: '20px',
      height: '35px',
    },
    comboLabel: {
      margin: '16px',
    },
  })
);

export const FooterBaseStyle = makeStyles(
  createStyles({
    buttonStyle: {
      maxWidth: '180px',
      maxHeight: '35px',
      minWidth: '180px',
      minHeight: '35px',
    },
  })
);
